import { Fragment, useMemo } from "react";
import { Card, CardBody, Col, Row, Button, Input} from "reactstrap";
import DataTable from "../../Components/DataTable";
import { FaEdit } from "react-icons/fa";

const formatCurrency = (value) => {
  if (value === null || value === undefined) return "$0";
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(value);
};

const getCityColumns = (onEdit) => [
  { header: "Ciudad", accessorKey: "name", cell: (info) => info.getValue() },
  { header: "Provincia", accessorKey: "provinceName", cell: (info) => info.getValue() },
  { header: "Costo de envío", accessorKey: "shippingCost", cell: (info) => formatCurrency(info.getValue()) },
  {
    header: "Acciones",
    accessorKey: "actions",
    cell: (info) => (
      <Button size="sm" color="primary" onClick={() => onEdit(info.row.original)}>
         <FaEdit /> 
      </Button>
      
    ),
  },
];

export const CityList = ({
  onEdit,
  data,
  isLoading,
  pagination,
  setPagination,
  onFilterChange,
  filterValue,
  onSearch
}) => {
  const columns = useMemo(() => getCityColumns(onEdit), [onEdit]);

  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              {/* Filtro y botón de búsqueda */}
              <Row className="mb-3">
                <Col sm="12" className="d-flex align-items-center gap-2">
                  <Input
                    style={{ maxWidth: 200 }}
                    placeholder="ciudad/provincia"
                    value={filterValue}
                    onChange={(e) => onFilterChange(e.target.value)}
                  />
                  <Button color="primary" onClick={onSearch}>
                    Buscar
                  </Button>
                </Col>
              </Row>
              {/* Tabla de ciudades */}
              <DataTable
                data={data?.data?.cities ?? []}
                total={data?.data?.total ?? 0}
                pagination={pagination}
                setPagination={setPagination}
                columns={columns}
                progressPending={isLoading}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};
